import React, { useCallback, useState, useEffect, useRef } from 'react'
import { Link } from 'react-router-dom'
import './styles.css'

type Props = {
    items: {
        label: string
        onClick?: () => void
        href?: string
        danger?: boolean
        title?: string
    }[]
}

export const Dropdown: React.FC<Props> = ({
  items
}) => {
  const dropdownRef = useRef<HTMLDivElement>(null)
  const [isOpen, setIsOpen] = useState(false)

  const handleClickOutside = useCallback((event: MouseEvent) => {
    if (dropdownRef.current && !dropdownRef.current.contains(event.target as Node)) {
      setIsOpen(false)
    }
  }, [dropdownRef])

  const handleEscapeKeyPress = useCallback((event: KeyboardEvent) => {
    if (isOpen && event.key === 'Escape') {
      setIsOpen(false)
    }
  }, [isOpen])

  useEffect(() => {
    if (!isOpen) {
      return
    }

    document.addEventListener('mousedown', handleClickOutside)

    return () => {
      document.removeEventListener('mousedown', handleClickOutside)
    }
  }, [handleClickOutside, isOpen])

  useEffect(() => {
    document.addEventListener('keydown', handleEscapeKeyPress)

    return () => {
      document.removeEventListener('keydown', handleEscapeKeyPress)
    }
  }, [handleEscapeKeyPress])

  return (
    <div className="dropdown-container" ref={dropdownRef}>
      <button
        type="button"
        aria-haspopup="listbox"
        aria-expanded={isOpen}
        onClick={() => setIsOpen(!isOpen)}
        className="dropdown-activator"
      >
        <svg xmlns="http://www.w3.org/2000/svg" width="32" height="32" viewBox="0 0 256 256" className="dropdown-icon"><path d="M144,128a16,16,0,1,1-16-16A16,16,0,0,1,144,128ZM60,112a16,16,0,1,0,16,16A16,16,0,0,0,60,112Zm136,0a16,16,0,1,0,16,16A16,16,0,0,0,196,112Z"></path></svg>
      </button>
      {isOpen && (
        <ul tabIndex={-1} role="listbox">
          {items.map(item => (
            <li 
              className={item.danger ? 'danger' : ''}
              key={item.label} 
              role="option"
            >
              {item.href
                ? <Link to={item.href} title={item.title}>{item.label}</Link>
                : <button type="button" onClick={item.onClick} title={item.title}>{item.label}</button>
              }
            </li>
          ))}
        </ul>
      )}
    </div>
  )
}

